<template>
  <div class="sabbatical__filter">
    <div class="sabbatical__header">Danh sách đơn nghỉ phép</div>
    <div class="card-table-emloyee">
      <CRow class="mx-0">
        <CCol
          sm="4"
          lg="3"
          md="3"
          xxl="2"
          class="pr-3 px-0"
          v-if="tabActive === 'need_approve'"
        >
          <div>
            <label>{{
                $t(
                  "placeholder.label_employee_over_time_request_search_code_name"
                )
              }}</label>
            <input
              class="form-control"
              @change="search"
              v-model="employeeInfo"
              v-on:keyup.enter="search"
              :placeholder="
                this.$t(
                  'placeholder.label_employee_over_time_request_search_code_name'
                )
              "
            />
          </div>
        </CCol>
        <CCol
          sm="4"
          lg="3"
          md="3"
          xxl="2"
          class="pr-3 px-0"
          v-if="tabActive === 'need_approve'"
        >
          <div>
            <label>{{ $t("employee.label_employee_position") }}</label>
            <select class="form-control" v-model="positionId" @change="search">
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.id"
                v-for="(item, index) in positions"
                :key="index"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol sm="4" lg="3" md="3" xxl="2" class="pr-3 px-0">
          <div>
            <label class="month">Từ ngày</label>
            <a-date-picker
              class="datepicker__input"
              placeholder=""
              format="DD/MM/YYYY"
              v-model="startDate"
              :allowClear="false"
              :disabled-date="disableMonth"
            />
          </div>
        </CCol>
        <CCol sm="4" lg="3" md="3" xxl="2" class="pr-3 px-0">
          <div>
            <label class="month">Đến ngày</label>
            <a-date-picker
              class="datepicker__input"
              placeholder=""
              format="DD/MM/YYYY"
              v-model="endDate"
              :allowClear="false"
              :disabled-date="disableMonth"
            />
          </div>
        </CCol>
        <CCol
          sm="4"
          lg="3"
          md="3"
          xxl="2"
          class="pr-3 pt-2 px-0"
          v-if="tabActive === 'need_approve'"
        >
          <div>
            <label>{{ $t("employee.label_employee_division") }}</label>
            <select
              class="form-control"
              v-model="divisionCode"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.code"
                v-for="(item, index) in divisions"
                :key="index"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol
          sm="4"
          lg="3"
          md="3"
          xxl="2"
          class="pr-3 pt-2 px-0"
          v-if="tabActive === 'need_approve'"
        >
          <div>
            <label>{{ $t("label.reason") }}</label>
            <select class="form-control" v-model="reason" @change="search">
              <option value="0">{{ $t("employee.select_option") }}</option>
              <option
                v-for="(option, index) in commonReasons"
                :key="index"
                :value="option.code"
              >
                {{ $t(`commons.label_reason_sabbatical_leave_${option.code}`) }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol
          sm="4"
          lg="3"
          md="3"
          xxl="2"
          class="pr-3 px-0"
          v-if="tabActive === 'mine'"
        >
          <div>
            <!-- <label class="month">Tháng</label>
            <a-month-picker
              class="datepicker__input"
              placeholder="Tháng"
              format="MM/YYYY"
              v-model="month"
              @change="search"
              :allowClear="false"
              :disabled-date="disableMonth"
            />
          </div> -->
            <label class="month">{{
              $t("commons.label_approve_person")
            }}</label>
            <input
              class="form-control"
              v-model="approvePerson"
              :placeholder="
                this.$t('placeholder.label_approve_person_over_time_request')
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol
          sm="4"
          lg="3"
          md="3"
          xxl="2"
          class="pr-3 px-0"
          v-if="tabActive === 'mine'"
        >
          <div>
            <label>{{ $t("commons.label_status") }}</label>
            <select class="form-control" v-model="status" @change="search">
              <option value="0">
                {{ $t("employee.select_all_option") }}
              </option>
              <option value="1" class="employee__badge color-status-1">
                {{ $t("commons.label_status_overtime_request_1") }}
              </option>
              <option value="2" class="employee__badge color-status-2">
                {{ $t("commons.label_status_overtime_request_2") }}
              </option>
              <option value="3" class="employee__badge color-status-3">
                {{ $t("commons.label_status_overtime_request_3") }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol
          sm="4"
          lg="3"
          md="3"
          xxl="2"
          class="pr-3 pt-2 px-0"
          v-if="tabActive === 'need_approve'"
        >
          <div>
            <label>{{ $t("commons.label_status") }}</label>
            <select class="form-control" v-model="statusTab2" @change="search">
               <option value="0">
                {{ $t("employee.select_option") }}
              </option>
              <option value="1">{{
                $t("commons.label_status_sabbatical_leave_request_1")
              }}</option>
              <option value="2">{{
                $t("commons.label_status_sabbatical_leave_request_2")
              }}</option>
              <option value="3">{{
                $t("commons.label_status_sabbatical_leave_request_3")
              }}</option>
            </select>
          </div>
        </CCol>
        <CCol
          sm="4"
          lg="3"
          md="3"
          xxl="2"
          class="pr-3 pt-2 px-0"
          v-if="tabActive === 'need_approve'"
        >
          <div>
            <label>{{ $t("commons.label_status_approve") }}</label>
            <select
              class="form-control"
              v-model="approveStatus"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option value="1">
                {{ $t("overtime.employee_approval_1") }}
              </option>
              <option value="2">
                {{ $t("overtime.employee_approval_2") }}
              </option>
              <option value="3">
                {{ $t("overtime.employee_approval_3") }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol sm="12" lg="12" md="12" class="btn-search text-center px-0">
          <CButton class="btn-search-employee" @click.prevent="search">
            <img src="../../../assets/icons/icon-search-white.svg" alt="" />
            {{ $t("button.label_employee_btn_search") }}
          </CButton>
        </CCol>
      </CRow>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "SabbaticalFilter",
  props: {
    propsMonth: {
      type: String,
      default: "",
    },
    tabActive: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      startDate: moment().startOf("month"),
      endDate:null,
      month: moment(),
      status: 0,
      statusTab2: 0,
      employeeInfo: "",
      approvePerson: "",
      approveStatus: 1,
      reason: 0,
      divisionCode: 0,
      positionId: 0,
    };
  },
  computed: {
    ...mapGetters({
      account: "auth/account",
      divisions: "commons/divisions",
      positions: "commons/positions",
      commonReasons: "sabbatical-leave-request/commonReasons",
    }),
  },
  created() {
    if (this.propsMonth) {
      this.month = moment(this.propsMonth, "DD/MM/YYYY");
    }
  },
  methods: {
    search() {
      let searchField = {};
      if (this.tabActive === "mine") {
        searchField =
          {
            startDate:this.startDate,
            endDate:this.endDate,
            // month: this.month,
            status: this.status,
            approvePerson: this.approvePerson,
          };
      }
      if (this.tabActive === "need_approve") {
        searchField =
          {
            startDate:this.startDate,
            endDate:this.endDate,
            // month: this.month,
            employeeInfo: this.employeeInfo,
            statusTab2: this.statusTab2,
            approveStatus: this.approveStatus,
            reason: this.reason,
            divisionCode: this.divisionCode,
            positionId: this.positionId,
          };
      }
      this.$emit("updateFilter", searchField);
    },
    disableMonth(current) {
      return (
        current &&
        (current < moment("3/2018", "M/YYYY"))
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.sabbatical__header {
  font-weight: 700;
  line-height: 22px;
  font-weight: 700;
  font-size: 18px;
  color: #3d4cdc;
  padding-bottom: 19px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 19px;
}
.sabbatical__filter {
  background: #ffffff;
  padding: 19px 24px;
  margin: -2rem 0 12px 0px;

  .sabbatical__header {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #3d4cdc;
    padding-bottom: 19px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 19px;
  }

  .form-control {
    height: 40px;
    border-radius: 10px;
  }

  .card-table-emloyee {
    .btn-search-employee {
      height: 40px;
    }
  }

  .btn-datepicker {
    margin-top: 20px;
    width: 127px;
    font-size: 16px;
    height: 40px;
    padding: 8px;
    background: #118fa6;
    border-radius: 5px;
    color: #ffffff;
  }
}

.datepicker__input {
  width: 100%;
}
.month {
  display: block;
}
.min-w-200 {
  width: 232px;
  min-width: 200px;
}
.btn-datepicker {
  margin-top: 20px;
  width: 127px;
  font-size: 16px;
  height: 40px;
  padding: 8px;
  background: #118fa6;
  border-radius: 5px;
  color: #ffffff;
}
.btn-search {
  padding-top: 28px;
}
.btn-search-employee {
  background: #3d4cdc;
  color: #ffffff;
  padding: 10px;
  border-radius: 10px;
  min-width: 200px;
  cursor: pointer;
  outline: none;
  border: none;
}
.svg-icon-custom {
  color: #fff;
  fill: #fff;
}
label.month {
  display: block;
}
</style>
<style lang="scss">
.ant-input {
  height: 35px;
}
.sabbatical__filter {
  .ant-input {
    height: 40px;
    border-radius: 10px;
  }
}
</style>
